<template>
  <el-dialog title :visible.sync="dialogVisible" :modal="false" :close-on-click-modal="false" :close-on-press-escape="false" width="900px" :append-to-body="true">
    <el-container direction="vertical">
      <el-header v-if="selectedCategory.length > 0" height="auto" style="border-bottom:1px solid #eee;padding:20px">
        <el-row class="mb10" :gutter="6">
          <el-col :span="2" style="font-size:16px"> <b>已选择:</b> </el-col>
          <el-col :offset="16" :span="3">
            <el-button type="primary" size="mini" style="width:100%" @click="submitData">确定</el-button>
          </el-col>
          <el-col :span="3">
            <el-button size="mini" style="width:100%" @click="cancel">取消</el-button>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-tag v-for="item in selectedCategory" :key="item._id" closable size="medium" style="cursor:pointer" class="mr10 mb10" effect="plain" @close="removeCategory(item)">{{ item }}</el-tag>
          </el-col>
        </el-row>
      </el-header>
      <el-container class="mb20" style="padding:20px 0">
        <el-aside style="height:50vh;overflow:scroll" width="220px">
          <el-menu :default-active="curFirst" @select="selectFirst">
            <el-menu-item v-for="item in first" :key="item" :index="item">
              {{ item }}
              <el-badge v-if="firstNum(item) !== 0" class="mark" :value="firstNum(item)" />
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-main style="height:50vh;overflow:scroll">
          <div class="tag-group" v-for="(item,idx) in categoryData" :key="idx">

            <div class="tag-title">{{item.name}}</div>
            <el-tag v-for="child in item.children" :key="child.name" size="medium" style="cursor:pointer;border:none;font-size:14px;width:170px;display:inline-flex;justify-content:space-between;align-items:center" class="mr10 mb10 custom-tags" :effect="tagType(child.name)" :closable="tagType(child.name) === 'dark'" @close="removeCategory(child.name)" @click="selectCategory(child.name)">{{ child.name }}</el-tag>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </el-dialog>
</template>
<script>
export default {
  filters: {
    formatPingtai(val) {
      const temp = { A: '大平台', B: '中型平台', C: '小平台' }
      return val ? temp[val] : '未分类公司'
    },
  },
  data: function () {
    return {
      dialogVisible: false,
      rawData: {},
      categoryData: [],
      first: [],
      selectedCategory: [],
      curFirst: '',
      resultCategory: [],
    }
  },
  mounted() {
    this.getCompany()
  },
  methods: {
    selectFirst(index) {
      this.curFirst = index
      this.categoryData = this.rawData[index]
    },
    async getCompany() {
      const { data } = await app.service('wechat').externalApi({
        path: '/api/jobs/newJobCategoryDetail',
        method: 'GET',
      })
      const sortMap = {
        模拟芯片设计: 1,
        数字芯片设计: 2,
        EDA开发: 3,
        芯片销售: 4,
        芯片设计相关软件开发: 5,
        芯片设计其他技术类: 6,
        人力资源: 7,
        FA: 8,
    }
      this.rawData = data
      const first = Object.keys(data)
      first.sort((a,b) => (sortMap[a]||999) - (sortMap[b]||999))
      this.first = first
    },
    tagType(name) {
      return this.selectedCategory.some((val) => name === val) ? 'dark' : 'plain'
    },
    firstNum(first) {
      let num = 0
      for (let s of this.selectedCategory) {
        for (let r of this.rawData[first]) {
          if (r.children.some((c) => c.name === s)) {
            num++
          }
        }
      }
      return num
    },
    open(defaultCompanies, onConfirm) {
      this.dialogVisible = true
      this.selectedCategory = defaultCompanies
      if (!this.selectedCategory || !this.selectedCategory.length) {
        this.selectFirst(this.first[0])
      } else {
        for (let s of this.selectedCategory) {
          for (let f of this.first) {
            for (let r of this.rawData[f]) {
              if (r.children.some((c) => c.name === s)) {
                this.selectFirst(f)
                return
              }
            }
          }
        }
      }
      // if (Array.isArray(defaultCompanies)) {
      //   this.selectedCategory = this.companyData.filter((v) => defaultCompanies.includes(v.简称))
      // }
      // if (onConfirm) this.onConfirm = onConfirm
    },
    selectCategory(item) {
      this.selectedCategory.every((val) => item !== val)
        ? this.selectedCategory.push(item)
        : (this.selectedCategory = this.selectedCategory.filter((val) => item !== val))
    },
    removeCategory(item) {
      this.selectedCategory = this.selectedCategory.filter((val) => item !== val)
    },
    submitData() {
      const submitData = this.selectedCategory.map((val) => val)
      if (submitData.length === 0) {
        this.$message({
          message: '请选择至少一个职能',
          type: 'warning',
        })
        return
      }
      this.$emit('confirm', submitData)
      this.onConfirm && this.onConfirm(submitData)
      this.dialogVisible = false
      this.selectedCategory = []
    },
    cancel() {
      this.dialogVisible = false
      this.selectedCategory = []
    },
  },
}
</script>
<style scoped src="../../statistics/css/hunting.css"></style>
<style scoped>
.custom-tags {
  color: #303133;
}
.custom-tags.el-tag--dark {
  color: #fff;
}
.custom-tags.el-tag--dark:hover {
  color: #fff;
}
.custom-tags:hover {
  color: #409eff;
}
.tag-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
  color: #999;
}
</style>
<style>
.fz14 .el-radio-button--small .el-radio-button__inner {
  font-size: 14px !important;
}
</style>
